import React, { FC } from "react";

import { Copyright as CopyrightComponent } from "../../../components/Copyright/Copyright";

import { useSharedProjectBaseMap } from "../../../hooks/sharing/useSharedProject";

export const Copyright: FC = () => {
  const baseMap = useSharedProjectBaseMap();

  return <CopyrightComponent basemap={baseMap} />;
};
